// extracted by mini-css-extract-plugin
export default {"wrapper":"students-list-modal_wrapper__uApW1"};